import _ from 'lodash';

export default {
    namespace: true,

    state: {
        discrepancyReports: {},
        currDiscrepancyReport: {},
    },

    mutations: {
        SET_DISCREPANCY_REPORTS(state, discrepancyReports) {
            state.discrepancyReports = discrepancyReports;
        },
        SET_CURR_SET_DISCREPANCY_REPORT(state, currDiscrepancyReport) {
            state.currDiscrepancyReport = currDiscrepancyReport;
        },
    },

    actions: {
        setAllDiscrepancyReports(vuexContext, discrepancyReports) {
            vuexContext.commit('SET_DISCREPANCY_REPORTS', discrepancyReports);
        },
        updateAllDiscrepancyReports(vuexContext, newDiscrepancyReports) {
            let discrepancyReports = vuexContext.getters.discrepancyReports;

            _.forEach(newDiscrepancyReports, (value, key) => {
                discrepancyReports[key] = value;
            });

            vuexContext.commit('SET_DISCREPANCY_REPORTS', discrepancyReports);
        },
    },

    getters: {
        discrepancyReports(state) {
            if (!_.isEmpty(state.discrepancyReports)) {
                return state.discrepancyReports;
            }
            return {};
        },
        currDiscrepancyReport(state) {
            if (!_.isEmpty(state.currDiscrepancyReport)) {
                return state.currDiscrepancyReport;
            }
            return {};
        },
    },
};
